import { SearchContainer } from "./components/SearchContainer/SearchContainer";
import { SorterContainer } from "./components/SorterContainer/SorterContainer";
import style from "./ControlPanel.module.scss";

export function ControlPanel() {
    return (
        <div className={style.container}>
            <SearchContainer />
            <SorterContainer />
        </div>
    )
}